import styled from 'styled-components';

export const StyledSeatSummaryWrapper = styled.div`
  display: flex;
`;

export const StyledSeatTitle = styled.h5`
  color: #33373d;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
`;

export const StyledSeatText = styled.div`
  color: #6e7582;
  font-size: 14px;
`;

export const StyledSeatSummary = styled.div`
  padding: 8px;
  flex-grow: 1;
  max-width: 200px;
  margin-right: 8px;
  background: #f9f9fb;
  border-radius: 3px;
  border: 1px solid #dfe3ec;
`;

export const StyledSelectWrapper = styled.div`
  color: #33373d;
  margin-top: 24px;
`;

export const StyledHeading = styled.h6`
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
`;

export const StyledText = styled.p`
  color: #6e7582;
  font-size: 12px;
  margin-bottom: 8px;
`;
